import React from 'react';
import { MailIcon, PhoneIcon, MapPinIcon, FacebookIcon, TwitterIcon, InstagramIcon, LinkedinIcon, ArrowUpIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#1B2A4A] text-slate-400 py-16 md:py-24 px-6 md:px-12 lg:px-16 pb-32 md:pb-24 relative" data-id="element-95">
      <div className="max-w-7xl mx-auto" data-id="element-96">
        {/* Top Section */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center border-b border-white/10 pb-12 mb-12" data-id="element-97">
          <div className="mb-8 md:mb-0" data-id="element-98">
            <div className="flex items-center gap-2.5 text-3xl font-bold text-white tracking-tight mb-4" data-id="element-99">
              <div className="bg-[#E8913A] text-white p-1.5 rounded-lg shadow-sm flex items-center justify-center" data-id="element-100">
                <svg viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6" data-id="element-101">
                  <path d="M11.47 3.84a.75.75 0 011.06 0l8.99 9a.75.75 0 11-1.06 1.06l-1.21-1.21V20a1 1 0 01-1 1h-4.5a1 1 0 01-1-1v-4a1 1 0 00-1-1h-2a1 1 0 00-1 1v4a1 1 0 01-1 1H4.75a1 1 0 01-1-1v-7.31l-1.21 1.21a.75.75 0 11-1.06-1.06l8.99-9z" data-id="element-102" />
                </svg>
              </div>
              <span data-id="element-103">
                Bevo Coastal <span className="text-[#E8913A]" data-id="element-104">Investments</span>
              </span>
            </div>
            <p className="text-lg text-slate-300 max-w-md font-light" data-id="element-105">
              Premium real estate solutions for homeowners who value their time
              and peace of mind.
            </p>
          </div>
          <div className="flex gap-4" data-id="element-106">
            <a href="#" className="w-11 h-11 rounded-full bg-white/5 flex items-center justify-center hover:bg-[#E8913A] hover:text-white transition-colors" data-id="element-107">
              <FacebookIcon className="w-5 h-5" data-id="element-108" />
            </a>
            <a href="#" className="w-11 h-11 rounded-full bg-white/5 flex items-center justify-center hover:bg-[#E8913A] hover:text-white transition-colors" data-id="element-109">
              <TwitterIcon className="w-5 h-5" data-id="element-110" />
            </a>
            <a href="#" className="w-11 h-11 rounded-full bg-white/5 flex items-center justify-center hover:bg-[#E8913A] hover:text-white transition-colors" data-id="element-111">
              <InstagramIcon className="w-5 h-5" data-id="element-112" />
            </a>
            <a href="#" className="w-11 h-11 rounded-full bg-white/5 flex items-center justify-center hover:bg-[#E8913A] hover:text-white transition-colors" data-id="element-113">
              <LinkedinIcon className="w-5 h-5" data-id="element-114" />
            </a>
          </div>
        </div>

        {/* Columns */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16" data-id="element-115">
          <div className="md:col-span-2" data-id="element-116">
            <h4 className="text-white font-semibold mb-6 text-lg" data-id="element-117">About Us</h4>
            <p className="mb-6 max-w-md leading-relaxed" data-id="element-118">
              We are a local real estate investment company that buys houses for
              cash. We provide win-win solutions to help homeowners get out of
              their sticky situations without the traditional market hassles.
            </p>
          </div>

          <div data-id="element-119">
            <h4 className="text-white font-semibold mb-6 text-lg" data-id="element-120">
              Contact Us
            </h4>
            <ul className="space-y-4" data-id="element-121">
              <li className="flex items-center" data-id="element-122">
                <PhoneIcon className="w-5 h-5 mr-3 flex-shrink-0 text-[#E8913A]" data-id="element-123" />
                <a href="tel:8883417570" className="hover:text-white transition-colors" data-id="element-124">
                  (888) 341-7570
                </a>
              </li>
              <li className="flex items-center" data-id="element-125">
                <MailIcon className="w-5 h-5 mr-3 flex-shrink-0 text-[#E8913A]" data-id="element-126" />
                <a href="mailto:Info@bevocoastalinvestments.com" className="hover:text-white transition-colors" data-id="element-127">
                  Info@bevocoastalinvestments.com
                </a>
              </li>
              <li className="flex items-start" data-id="element-128">
                <MapPinIcon className="w-5 h-5 mr-3 mt-1 flex-shrink-0 text-[#E8913A]" data-id="element-129" />
                <span className="leading-relaxed" data-id="element-130">
                  7901 4th Street N, Ste 300
                  <br data-id="element-131" />
                  St. Petersburg, FL 33702
                </span>
              </li>
            </ul>
          </div>

          <div data-id="element-132">
            <h4 className="text-white font-semibold mb-6 text-lg" data-id="element-133">
              Service Areas
            </h4>
            <ul className="space-y-3" data-id="element-134">
              <li data-id="element-135">Miami, FL</li>
              <li data-id="element-136">Orlando, FL</li>
              <li data-id="element-137">Tampa, FL</li>
              <li data-id="element-138">Jacksonville, FL</li>
              <li data-id="element-139">Fort Lauderdale, FL</li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-white/10 text-sm flex flex-col md:flex-row justify-between items-center relative" data-id="element-140">
          <p data-id="element-141">
            &copy; {new Date().getFullYear()} Bevo Coastal Investments LLC. All
            rights reserved.
          </p>
          <div className="flex space-x-6 mt-6 md:mt-0" data-id="element-142">
            <a href="#/privacy" className="hover:text-white transition-colors" data-id="element-143">
              Privacy Policy
            </a>
            <a href="#/terms" className="hover:text-white transition-colors" data-id="element-144">
              Terms of Service
            </a>
          </div>

          {/* Back to top */}
          <button onClick={() => window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })} className="absolute right-0 -top-6 md:top-auto md:relative w-10 h-10 bg-white/5 hover:bg-[#E8913A] text-white rounded-full flex items-center justify-center transition-colors" aria-label="Back to top" data-id="element-145">
            <ArrowUpIcon className="w-5 h-5" data-id="element-146" />
          </button>
        </div>
      </div>
    </footer>;
}